// MA Bachat Bazar theme JS
document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-main-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // Quantity steppers on cart page
  document.querySelectorAll('[data-qty-input]').forEach(function (input) {
    var minus = input.parentElement.querySelector('[data-qty-minus]');
    var plus = input.parentElement.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(0, parseInt(input.value || '1', 10) - 1);
      input.form.submit();
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
      input.form.submit();
    });
  });

});
